import { X } from 'lucide-react';

import { clsx } from 'clsx';

import { ICON_DEFAULT } from '@shared/constants/colors';

import cls from './CloseIcon.module.scss';

type CloseIconProps = {
  className?: string;
  onClick: () => void;
  size?: number;
  color?: string;
  testId?: string;
};

export const CloseIcon = ({ className, onClick, size = 20, color = ICON_DEFAULT, testId }: CloseIconProps) => {
  return (
    <button
      data-testid={testId}
      aria-label={'Закрыть'}
      onClick={onClick}
      className={clsx(cls.item, className)}
    >
      <X
        size={size}
        color={color}
      />
    </button>
  );
};
